// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-range-picker[data-v-c326ce7c]{min-width:0;width:100%}.date-range-picker__calendars[data-v-c326ce7c]{align-items:stretch;background:#fff;display:flex;overflow:hidden}.date-range-picker__calendars--stacked[data-v-c326ce7c]{flex-direction:column}.date-range-picker__calendar[data-v-c326ce7c]{border-radius:0;flex:0 0 auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
